module.exports = __webpack_public_path__ + "static/media/practice-icon-white.126ae93a.svg";